import { render, staticRenderFns } from "./LoanOverviewCustomer.vue?vue&type=template&id=45f4a249&lang=pug&"
import script from "./LoanOverviewCustomer.vue?vue&type=script&lang=js&"
export * from "./LoanOverviewCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports